import type { RequestOptions } from '@nextgen-web-framework/core';
import { HTTPVerbs } from '@nextgen-web-framework/core';

export function postAddressReqObj(versionId: string): RequestOptions {
  return {
    url: `/comcontactas/${versionId}/contacts`,
    method: HTTPVerbs.POST,
    retries: 0,
  };
}

export function getAddressListReqObj(versionId: string): RequestOptions {
  return {
    url: `/comcontactas/${versionId}/contacts`,
    method: HTTPVerbs.GET,
    retries: 0,
  };
}

export function getAddressByContactIdReqObj(versionId: string, contactId: string): RequestOptions {
  return {
    url: `/comcontactas/${versionId}/contacts/${contactId}`,
    method: HTTPVerbs.GET,
    retries: 0,
  };
}

export function putAddressListReqObj(versionId: string, contactId: string): RequestOptions {
  return {
    url: `/comcontactas/${versionId}/contacts/${contactId}`,
    method: HTTPVerbs.PUT,
    retries: 0,
  };
}

export function getCheckUserReqObj(versionId: string): RequestOptions {
  return {
    url: `/comprofileas/${versionId}/checkUser`,
    method: HTTPVerbs.GET,
    retries: 0,
  };
}

export function getCheckUserExistsReqObj(versionId: string): RequestOptions {
  return {
    url: `/comaccountas/${versionId}/checkUser`,
    method: HTTPVerbs.GET,
    retries: 0,
  };
}

export function getProfilesReqObj(versionId: string): RequestOptions {
  return {
    url: `/comprofileas/${versionId}/profiles`,
    method: HTTPVerbs.GET,
    retries: 0,
  };
}

export function getProfilesGovernmentRecordsReqObj(versionId: string): RequestOptions {
  return {
    url: `/comprofileas/${versionId}/government-records`,
    method: HTTPVerbs.GET,
    retries: 0,
  };
}

export function postProfilesGovernmentRecordsReqObj(versionId: string): RequestOptions {
  return {
    url: `/comprofileas/${versionId}/government-records`,
    method: HTTPVerbs.POST,
    retries: 0,
  };
}

export function patchProfilesGovernmentRecordsReqObj(versionId: string): RequestOptions {
  return {
    url: `/comprofileas/${versionId}/government-records`,
    method: HTTPVerbs.PATCH,
    retries: 0,
  };
}

export function getSearchSponsorReqObj(versionId: string): RequestOptions {
  return {
    url: `/comregistrationas/${versionId}/sponsors`,
    method: HTTPVerbs.GET,
    retries: 0,
    timeout: 60000,
  };
}

export function getRegistrationObj(versionId: string): RequestOptions {
  return {
    url: `/comregistrationas/${versionId}/registrations`,
    method: HTTPVerbs.GET,
    retries: 0,
  };
}

export function postRegistrationObj(versionId: string): RequestOptions {
  return {
    url: `/comregistrationas/${versionId}/registrations`,
    method: HTTPVerbs.POST,
    retries: 0,
  };
}

export function patchRegistrationObj(versionId: string): RequestOptions {
  return {
    url: `/comregistrationas/${versionId}/registrations`,
    method: HTTPVerbs.PATCH,
    retries: 0,
    timeout: 60000,
  };
}
export function postSubmitRegistrationObj(versionId: string, registrationId: string): RequestOptions {
  return {
    url: `/comregistrationas/${versionId}/registrations/${registrationId}/submit`,
    method: HTTPVerbs.POST,
    retries: 3,
    timeout: 60000,
  };
}

export function getContactSearchObj(versionId: string): RequestOptions {
  return {
    url: `/comcontactas/${versionId}/contact-search`,
    method: HTTPVerbs.GET,
    retries: 0,
  };
}

export function getContactDaneCodeObj(versionId: string): RequestOptions {
  return {
    url: `/comcontactas/${versionId}/daneCode`,
    method: HTTPVerbs.GET,
    retries: 0,
  };
}

/**
 * @deprecated This function is deprecated and will be removed in future versions.
 * Please use the postAccountChallengesObj function instead.
 */
export function postProfileChallengesObj(versionId: string, profileId: string): RequestOptions {
  return {
    url: `/comprofileas/${versionId}/profiles/${profileId}/challenges`,
    method: HTTPVerbs.POST,
    retries: 0,
  };
}

export function postAccountChallengesObj(versionId: string, accountNum: string): RequestOptions {
  return {
    url: `/comaccountas/${versionId}/accounts/${accountNum}/challenges`,
    method: HTTPVerbs.POST,
    retries: 0,
  };
}

export function getAccountAutoRenewalReqObj(versionId: string, accountNum: string): RequestOptions {
  return {
    url: `/comaccountas/${versionId}/accounts/${accountNum}/autoRenew`,
    method: HTTPVerbs.GET,
    retries: 0,
  };
}

export function deleteAccountAutoRenewalReqObj(versionId: string, accountNum: string): RequestOptions {
  return {
    url: `/comaccountas/${versionId}/accounts/${accountNum}/autoRenew`,
    method: HTTPVerbs.DELETE,
    retries: 0,
  };
}

export function patchProfilesReqObj(versionId: string): RequestOptions {
  return {
    url: `/comprofileas/${versionId}/profiles`,
    method: HTTPVerbs.PATCH,
    retries: 0,
  };
}

export function getTaskListReqObj(versionId: string): RequestOptions {
  return {
    url: `/comblocksprivilegesas/${versionId}/tasks`,
    method: HTTPVerbs.GET,
    retries: 0,
    timeout: 60000,
  };
}
export function postRegistrationChallengesObj(versionId: string, registrationId: string): RequestOptions {
  return {
    url: `/comregistrationas/${versionId}/registrations/${registrationId}/challenges`,
    method: HTTPVerbs.POST,
    retries: 0,
    timeout: 60000,
  };
}

export function deleteAddressListReqObj(versionId: string, contactId: string): RequestOptions {
  return {
    url: `/comcontactas/${versionId}/contacts/${contactId}`,
    method: HTTPVerbs.DELETE,
    retries: 0,
  };
}
export function getRegionAddressSearchObj(versionId: string, searchType: string): RequestOptions {
  return {
    url: `/comcontactas/${versionId}/${searchType}`,
    method: HTTPVerbs.GET,
    retries: 0,
  };
}
export function getContractListReqObj(versionId: string): RequestOptions {
  return {
    url: `/comcontractas/${versionId}/contracts`,
    method: HTTPVerbs.GET,
    retries: 0,
  };
}
export function patchContractReqObj(versionId: string): RequestOptions {
  return {
    url: `/comcontractas/${versionId}/contracts`,
    method: HTTPVerbs.PATCH,
    retries: 0,
  };
}

// Document: Get document list & single document
export function getDocumentReqObj(versionId: string): RequestOptions {
  return {
    url: `/comdocumentas/${versionId}/documents`,
    method: HTTPVerbs.GET,
    retries: 0,
  };
}

// Documents -> Upload Document
export function postDocumentReqObj(versionId: string): RequestOptions {
  return {
    url: `/comdocumentas/${versionId}/documents`,
    method: HTTPVerbs.POST,
    retries: 0,
  };
}

export function getAccountReqObj(versionId: string): RequestOptions {
  return {
    url: `/comaccountas/${versionId}/accounts`,
    method: HTTPVerbs.GET,
    retries: 0,
  };
}

export function getAccountDetailsReqObj(versionId: string): RequestOptions {
  return {
    url: `/comaccountsearchas/${versionId}/search`,
    method: HTTPVerbs.GET,
    retries: 0,
  };
}

export function getPublicationReqObj(versionId: string): RequestOptions {
  return {
    url: `/comprofilesubas/${versionId}/publications`,
    method: HTTPVerbs.GET,
    retries: 0,
  };
}

export function patchPublicationReqObj(versionId: string): RequestOptions {
  return {
    url: `/comprofilesubas/${versionId}/publications`,
    method: HTTPVerbs.PATCH,
    retries: 0,
  };
}

export function getAccountPhonesReqObj(versionId: string): RequestOptions {
  return {
    url: `/comaccountas/${versionId}/phones`,
    method: HTTPVerbs.GET,
    retries: 0,
  };
}
export function getAccountEmailsReqObj(versionId: string): RequestOptions {
  return {
    url: `/comaccountas/${versionId}/emails`,
    method: HTTPVerbs.GET,
    retries: 0,
  };
}
export function postAccountPhoneReqObj(versionId: string): RequestOptions {
  return {
    url: `/comaccountas/${versionId}/phones`,
    method: HTTPVerbs.POST,
    retries: 0,
  };
}
export function postAccountEmailReqObj(versionId: string): RequestOptions {
  return {
    url: `/comaccountas/${versionId}/emails`,
    method: HTTPVerbs.POST,
    retries: 0,
  };
}
export function patchAccountPhoneReqObj(versionId: string, phoneId: string): RequestOptions {
  return {
    url: `/comaccountas/${versionId}/phones/${phoneId}`,
    method: HTTPVerbs.PATCH,
    retries: 0,
  };
}
export function patchAccountEmailReqObj(versionId: string, emailId: string): RequestOptions {
  return {
    url: `/comaccountas/${versionId}/emails/${emailId}`,
    method: HTTPVerbs.PATCH,
    retries: 0,
  };
}

export function deleteAccountPhoneReqObj(versionId: string, phoneId: string): RequestOptions {
  return {
    url: `/comaccountas/${versionId}/phones/${phoneId}`,
    method: HTTPVerbs.DELETE,
    retries: 0,
  };
}
export function deleteAccountEmailReqObj(versionId: string, emailId: string): RequestOptions {
  return {
    url: `/comaccountas/${versionId}/emails/${emailId}`,
    method: HTTPVerbs.DELETE,
    retries: 0,
  };
}
